import { render, staticRenderFns } from "./v-tag-chip.vue?vue&type=template&id=18cf1eba"
import script from "./v-tag-chip.vue?vue&type=script&lang=js"
export * from "./v-tag-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports